import React from "react";
import { graphql } from "gatsby";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import { Container, Col, Row } from "react-bootstrap";
import Head from "../components/Head";
import MainLayout from "../components/MainLayout";
import HomeTopper from "../components/toppers/HomeTopper";
import HomeSectionWorks from "../components/home/HomeSectionWorks";
import HomeSectionBlogs from "../components/home/HomeSectionBlogs";
import * as styles from "./index.module.scss";

const IndexPage = ({ data: { prismicHome } }) => {
    const { data } = prismicHome;
    const [generalCard] = data.body.filter(
        (seoSlice) => seoSlice.slice_type === "general_card"
    );
    const [twitterCard] = data.body.filter(
        (seoSlice) => seoSlice.slice_type === "twitter_card"
    );
    return (
        <MainLayout variant="light" noBottomPadding>
            <Head
                generalCard={generalCard && generalCard.primary}
                twitterCard={twitterCard && twitterCard.primary}
                title={data.meta_title.text}
                description={data.meta_description.text}
            />

            <Container
                fluid
                as="section"
                id="homeTopper"
                className={styles.homeTopper}
            >
                <Row>
                    <Col>
                        <HomeTopper
                            title={prismicHome.data.page_title}
                            textBlock={prismicHome.data.text_block}
                            vimeoID={prismicHome.data.vimeo_id_for_video_header}
                            titleColor={prismicHome.data.title_color}
                            videoPlaceholder={
                                prismicHome.data.video_placeholder
                            }
                            bgImage={prismicHome.data.header_background_image}
                        />
                    </Col>
                </Row>
            </Container>

            {data.work_group && (
                <HomeSectionWorks
                    worksTitle={data.work_title.text}
                    works={data.work_group}
                    viewMoreWork
                />
            )}

            {data.blog_group && <HomeSectionBlogs blogs={data.blog_group} />}
        </MainLayout>
    );
};

export default withPrismicPreview(IndexPage);

export const homeQuery = graphql`
    {
        prismicHome {
            _previewable
            uid
            data {
                page_title {
                    text
                }
                vimeo_id_for_video_header {
                    text
                }
                meta_title {
                    text
                }
                meta_description {
                    text
                }
                header_background_image {
                    fluid(imgixParams: { auto: "none" }) {
                        ...GatsbyPrismicImageFluid
                    }
                    alt
                    copyright
                }
                video_placeholder {
                    fluid(imgixParams: { auto: "none" }) {
                        ...GatsbyPrismicImageFluid
                    }
                    alt
                    copyright
                }
                text_block {
                    text
                    html
                }
                title_color
                body {
                    ... on PrismicHomeDataBodyTwitterCard {
                        id
                        slice_type
                        primary {
                            description {
                                text
                            }
                            twitter_handle {
                                text
                            }
                            twitter_title {
                                text
                            }
                            image {
                                alt
                                url
                                dimensions {
                                    height
                                    width
                                }
                            }
                        }
                    }
                    ... on PrismicHomeDataBodyGeneralCard {
                        id
                        slice_type
                        primary {
                            title {
                                text
                            }
                            description {
                                text
                            }
                            type {
                                text
                            }
                            url {
                                text
                            }
                            locale {
                                text
                            }
                            image {
                                alt
                                url
                                dimensions {
                                    height
                                    width
                                }
                            }
                        }
                    }
                }
                work_title {
                    text
                }
                work_group {
                    work {
                        uid
                        tags
                        document {
                            ... on PrismicWork {
                                uid
                                data {
                                    main_menu_color
                                    client_name {
                                        text
                                    }
                                    case_study_name {
                                        text
                                    }
                                    banner_homepage_image {
                                        alt
                                        thumbnails {
                                            Mobile {
                                                alt
                                                url
                                                dimensions {
                                                    height
                                                    width
                                                }
                                            }
                                        }
                                        fluid(imgixParams: { auto: "none" }) {
                                            ...GatsbyPrismicImageFluid
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                blog_group {
                    blog {
                        uid
                        document {
                            ... on PrismicBlog {
                                uid
                                first_publication_date(formatString: "MMM D Y")
                                data {
                                    title {
                                        text
                                    }
                                    author {
                                        document {
                                            ... on PrismicPeople {
                                                data {
                                                    name {
                                                        text
                                                    }
                                                }
                                                uid
                                            }
                                        }
                                    }
                                    category_group {
                                        blog_category {
                                            slug
                                        }
                                    }
                                    featured_block_image {
                                        alt
                                        fluid(imgixParams: { auto: "none" }) {
                                            ...GatsbyPrismicImageFluid
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
